<template>
  <div class="wizard box">
    <component
      v-if="currentStepObj"
      :is="currentStepObj.component"
      :wizardData="wizardData"
      @next="nextStep"
      @prev="prevStep"
      @finish="finishWizard"
    />
  </div>
</template>

<script>
import StepOrganization from './StepOrganization.vue';
import StepPreferences from './StepPreferences.vue';
import StepFirstClient from './StepFirstClient.vue';
import StepFirstItem from './StepFirstItem.vue';
import StepConfirm from './StepConfirm.vue';

import api from '@/utils/axios';

export default {
  name: 'OnboardingWizard',
  components: {
    StepOrganization,
    StepPreferences,
    StepFirstClient,
    StepFirstItem,
    StepConfirm,
  },
  data() {
    return {
      stepIndex: 0,
      wizardData: {
        organization: {},
        preferences: {},
        firstClient: {},
        firstItem: {},
      },
      loading: false,
      error: null,
    };
  },
  computed: {
    currentStepObj() {
      const steps = [
        { name: 'Organization', component: StepOrganization },
        { name: 'Preferences', component: StepPreferences },
        { name: 'FirstClient', component: StepFirstClient },
        { name: 'FirstItem', component: StepFirstItem },
        { name: 'Confirm', component: StepConfirm },
      ];
      return steps[this.stepIndex] || null;
    },
  },
  methods: {
    nextStep(data) {
      // ✅ Merge les données reçues de chaque step
      if (data) {
        this.wizardData = { ...this.wizardData, ...data };
      }
      this.stepIndex++;
    },
    prevStep() {
      if (this.stepIndex > 0) this.stepIndex--;
    },
    async finishWizard(data) {
      if (data) {
        this.wizardData = { ...this.wizardData, ...data };
      }

      this.loading = true;
      this.error = null;

      try {
        await api.post('/organization/onboarding/complete/', this.wizardData);
        // 🔄 Refresh currentUser pour mettre org_onboarded à jour
        await this.$store.dispatch('fetchCurrentUser');

        // ✅ Une fois fini → dashboard
        this.$router.push('/dashboard');
      } catch (err) {
        console.error('Wizard finish error:', err.response?.data || err);
        this.error = err.response?.data || 'Erreur lors de l’enregistrement';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
